var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExlyPrimaryMain = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 29,
    viewBox: "0 0 57 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.524 5.18V9.156H11.936V12.852H5.524V17.164H12.776V21H0.736V1.344H12.776V5.18H5.524ZM25.1244 21L22.1284 16.66L19.6084 21H14.4284L19.5804 13.02L14.2884 5.376H19.6644L22.6604 9.688L25.1804 5.376H30.3604L25.1244 13.244L30.5004 21H25.1244ZM37.1334 0.28V21H32.3454V0.28H37.1334ZM56.5632 5.376L46.7632 28.42H41.6112L45.1952 20.468L38.8392 5.376H44.1872L47.7992 15.148L51.3832 5.376H56.5632Z",
    fill: "#4A3AB1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExlyPrimaryMain, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Exly_Primary_Main.96eb226d.svg";
export { ForwardRef as ReactComponent };